import React from 'react'
import { Field, reduxForm } from 'redux-form'
import FormFieldText from '../../../components/uiKit/FormFieldText'
///////// Validations//////////////


const passwordsMatch = (value, allValues) => 
  value !== allValues.password ? 'Passwords dont match' : undefined

const requiredNewPassword = value => value ? undefined : 'Please enter a new password'
const requiredConfirmPassword = value => value ? undefined : 'Please confirm your new password'

class ResetPasswordForm extends React.Component{


	render(){
		const { handleSubmit,signupError,submitLoading } = this.props


		return(
			<form 
				className={'signup-form ' + 
						(this.props.anyTouched ? ' signup-form--anyTouched ' : '') +
						(this.props.valid ? ' signup-form--valid ' : ' signup-form--invalid')
				} 
				onSubmit={handleSubmit}
			>						
				
				<Field 
					name='password'
					type='password'
					component={FormFieldText}
					placeholder='New Password'
					validate={[requiredNewPassword]}
					autoFocus={true}		    
				/>


				<Field 
					name='passwordMatch'
					type='password'      		
					component={FormFieldText}
					placeholder='Confirm Password'
					validate={[requiredConfirmPassword, passwordsMatch]}
				/>

		
				<button className="signup-form-submitBtn" type="submit">
						
					{!submitLoading &&	
						<React.Fragment>
							Confirm New Password
						</React.Fragment>
					}

					{submitLoading &&
					<div className='signup-form-submitBtn-loadingSpinnerContainer'>
						<div className='signup-form-submitBtn-loadingSpinner' />
					</div>
					}

				</button>

				{signupError &&
					<div className='signup-form-error'>   
						{signupError}
					</div> 
				}

			</form>     
		)
	}
}




ResetPasswordForm = reduxForm({
	form: 'resetPasswordForm',
})(ResetPasswordForm)

export default ResetPasswordForm
